import { deskChannels } from "@/mocks/home";
import Reveal from "@/components/feature/Reveal";

export default function LeakDeskSection() {
  return (
    <section id="desk" className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20composition%20of%20a%20locked%20steel%20vault%20door%20surrounded%20by%20drifting%20paper%20documents%20crimson%20and%20amber%20rim%20light%20mysterious%20investigative%20atmosphere%20cinematic%20deep%20shadows%20minimal%20no%20text&width=1600&height=900&seq=hw-desk-vault-31&orientation=landscape"
          alt="黑网爆料安全投递通道主视觉"
          title="黑网爆料 匿名爆料 线报投递 黑色产业链"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/88 via-foreground-950/85 to-foreground-950/95"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-[1400px] px-4 py-16 md:px-6 md:py-24 lg:px-10">
        <Reveal>
          <div className="border-t border-background-50/20 pt-6 md:pt-8">
            <div className="flex items-center gap-3">
              <span className="font-heading text-xs tracking-[0.35em] text-primary-400">06</span>
              <span className="text-xs tracking-[0.3em] text-background-300 uppercase">
                Leak Desk
              </span>
            </div>
            <div className="mt-4 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
              <h2 className="max-w-2xl font-heading text-2xl leading-snug text-background-50 md:text-4xl">
                你手里的那份材料
                <span className="text-primary-400">，可能就是下一条线索</span>
              </h2>
              <p className="max-w-lg text-sm leading-8 text-background-200">
                我们只关心材料本身是否真实、是否与黑灰产相关。投递全程可匿名，来源信息不会出现在任何一期合集中。
              </p>
            </div>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
          {deskChannels.map((channel, index) => (
            <Reveal key={channel.title} delay={index * 70}>
              <div className="flex h-full flex-col rounded-lg border border-background-50/15 bg-background-50/[0.04] p-6 transition-colors hover:border-primary-400/60">
                <span className="flex h-11 w-11 items-center justify-center rounded-md border border-background-50/20 text-primary-300">
                  <i className={`${channel.icon} text-lg`}></i>
                </span>
                <h3 className="mt-6 font-heading text-lg text-background-50">
                  {channel.title}
                </h3>
                <p className="mt-2 text-sm leading-7 text-background-300">{channel.desc}</p>
                <span className="mt-5 border-t border-background-50/15 pt-4 font-mono text-xs tracking-wide text-accent-300">
                  {channel.value}
                </span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-12 flex flex-col items-start gap-4 border-t border-background-50/15 pt-8 md:flex-row md:items-center md:justify-between">
            <p className="text-xs leading-6 text-background-300">
              提示：请勿在投递材料中附带你自己或他人的敏感证件信息，如需说明可先做遮盖处理。
            </p>
            <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
              <a
                href="#desk"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-send-plane-fill"></i>
                立即投递线报
              </a>
              <a
                href="#evidence"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-folder-shield-2-line"></i>
                查看材料库
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}